import React from "react";
import "./Home.css";
import Product from "./Product";

function Home() {
  return (
    <div className="home">
      <div className="home__container">
        <img
          className="home__image"
          src="https://i.imgur.com/UTEKJze.png"
          alt=""
        />
        <div className="home__row">
          <Product
            id="1318415"
            title="Ecofarwest 50FT,100FT,10 mm(3/8in) Braided Rope for Outdoor Rock Climbing Escape Rope Ice Climbing Equipment Fire Rescue Parachute Rope"
            price={24.99}
            image="https://m.media-amazon.com/images/I/91mK1OVSb2L._AC_UL480_FMwebp_QL65_.jpg"
            rating={5}
          />
          <Product
            id="13184582"
            title="Outlery | Portable & Reusable Stainless Steel Travel Cutlery Set With Case For Camping, Picnic, Office and On-The-Go (Pocket Sized Flatware Set)"
            price={39.9}
            image="https://images-na.ssl-images-amazon.com/images/I/81KT6mjPJFL._AC_SL1500_.jpg"
            rating={4}
          />
        </div>
        <div className="home__row">
          <Product
            id="1318053"
            title="Lisianthus
            Women Belt Buckle Fedora Hat"
            price={16.45}
            image="https://m.media-amazon.com/images/I/61D9k2EHQtL._AC_UL480_FMwebp_QL65_.jpg"
            rating={4}
          />
          <Product
            id="1318204"
            title="Wyze Cam 1080p HD Indoor WiFi Smart Home Camera with Night Vision, 2-Way Audio, Works with Alexa & the Google Assistant, White, 1-Pack"
            price={25.33}
            image="https://images-na.ssl-images-amazon.com/images/I/31KSWaj8AtL._AC_US327_FMwebp_QL65_.jpg"
            rating={5}
          />
          <Product
            id="1318596"
            title="Blush Pink Lamp Shade, Lamp Shade for Table Lamp, Small Lamp Shade, Various Sizes, Made to Order"
            price={59.99}
            image="https://m.media-amazon.com/images/I/51ISzJvy6XL._AC_UY327_FMwebp_QL65_.jpg"
            rating={3}
          />
        </div>
        <div className="home__row">
          <Product
            id="1308515"
            title="Wilson RUSH PRO 2.5 2019 Pickleball Shoes"
            price={99.0}
            image="https://m.media-amazon.com/images/I/71MJl-tcojL._AC_UL480_FMwebp_QL65_.jpg"
            rating={4}
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
